import React, { memo } from "react";
import cn from "classnames";

type Props = {
  active: boolean;
  onChange: any;
};
export const Switch = memo(({ active, onChange }: Props) => {
  return (
    <div
      onClick={onChange}
      aria-hidden="true"
      className={cn("w-7 h-4 flex items-center p-0.5 rounded-[30px] ", {
        "bg-accent": active,
        "bg-[#E1E1E1]": !active,
      })}
    >
      <div
        className={cn("w-3 h-3 rounded-full bg-white transition-all", {
          "translate-x-full": active,
        })}
      />
    </div>
  );
});
